import React, { useState, useEffect } from 'react';
import './feedback.css';

function Loading() {
    const [isLoading, setLoading] = useState(true);

    useEffect(() => {
        const timer = setTimeout(() => setLoading(false), 5000);
        return () => clearTimeout(timer);
    }, []);

    return isLoading ? (
        <div className="remote-loading" role="status" aria-live="polite">
            <span className="remote-loading-spinner" aria-hidden="true" />
            <span>Loading songs…</span>
        </div>
    ) : null;
}

export default Loading;
